var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-answer" }, [
    _c("div", { staticClass: "answer_wrap" }, [
      _c(
        "div",
        { staticClass: "answer_wrap__right_wrap" },
        [
          _vm.data.loading ? _c("Loading") : _vm._e(),
          _vm.data.content.length
            ? _c(
                "div",
                {
                  staticClass: "content_wrap",
                  staticStyle: { position: "relative" },
                  attrs: {
                    "data-streaming": _vm.data.streaming ? "true" : null,
                  },
                },
                _vm._l(_vm.data.content, function (u, o) {
                  return _c(
                    "div",
                    { key: o, staticClass: "content_wrap__item" },
                    [
                      (
                        _vm.$attrs.isShowOperate !== undefined
                          ? _vm.$attrs.isShowOperate
                          : false
                      )
                        ? [
                            _c("div", {
                              staticStyle: {
                                "white-space": "pre-line",
                                "word-break": "break-all",
                              },
                              domProps: { innerHTML: _vm._s(u.value || "") },
                            }),
                          ]
                        : [
                            u.type ==
                              _vm.answerContentTypeEnum.Object.TEXT.code &&
                            u.value
                              ? _c("MarkdownPlus", {
                                  staticClass: "md_body",
                                  attrs: { id: u.id, content: u.value || "" },
                                })
                              : [
                                  _vm._l(
                                    _vm.answerContentTypeEnum.Array,
                                    function (e, i) {
                                      return [
                                        e.code !==
                                        _vm.answerContentTypeEnum.Object.TEXT
                                          .code
                                          ? _vm._t(e.code + o, null, {
                                              data: {
                                                contentTypeData: e,
                                                params: _vm.data,
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    }
                                  ),
                                ],
                          ],
                    ],
                    2
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.formModalDataProp.answer &&
          _vm.formModalDataProp.answer.knowledgeDocument &&
          _vm.formModalDataProp.answer.knowledgeDocument.length
            ? _c(
                "div",
                { staticClass: "knowledge-files" },
                _vm._l(
                  _vm.formModalDataProp.answer.knowledgeDocument,
                  function (file, idx) {
                    return _c(
                      "div",
                      { key: idx, staticClass: "knowledge-files__item" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "knowledge-files__link",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.handleFilePreview(file)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(file.fileName) + " ")]
                        ),
                      ]
                    )
                  }
                ),
                0
              )
            : _vm._e(),
          _vm.data.chatAiResult == "error"
            ? [
                _c("div", { staticClass: "error_wrap" }, [
                  _vm._v("可能会导致报错或出现异常搜索结果"),
                ]),
              ]
            : _vm._e(),
          _c(
            "div",
            { staticClass: "operate_wrap" },
            [
              (_vm.$attrs.isShowOperate !== undefined
                ? _vm.$attrs.isShowOperate
                : true) &&
              (_vm.data.content.length ||
                _vm.data.streaming ||
                _vm.data.loading)
                ? _c(
                    "ActionsItem",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            dataProp: _vm.data,
                            indexProp: _vm.index,
                            formModalDataProp: _vm.formModalDataProp,
                            isDisabled:
                              _vm.data.streaming ||
                              _vm.data.loading ||
                              _vm.$store.state.aiChat.textareaIsDisabled,
                          },
                          on: {
                            "update:dataProp": function ($event) {
                              _vm.data = $event
                            },
                            "update:data-prop": function ($event) {
                              _vm.data = $event
                            },
                          },
                        },
                        "ActionsItem",
                        _vm.$attrs,
                        false
                      ),
                      _vm.$listeners
                    )
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }